'use client';

import CrosshairSvg from '@/public/icon/crosshair.svg';
import PinSvg from '@/public/icon/pin.svg';
import { Format } from '@/utils/format';
import handleMapOpen from '@/utils/handleMapOpen';

export default function Address({ place }: any) {
  if (!place?.address) return null;
  return (
    <div className='relative z-10 flex w-full items-center justify-between'>
      <div className='flex items-center space-x-2'>
        <PinSvg />
        <p>{Format.address({ ...place })}</p>
      </div>
      <button
        onClick={() =>
          handleMapOpen({
            latitude: place.latitude,
            longitude: place.longitude,
          })
        }
      >
        <CrosshairSvg />
      </button>
    </div>
  );
}
